import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Home|Dashboard|Appointments`;

export type CpDashboardAppointmentLoc =
	| 'CPDashboardAppointmentTitleAppointments'
	| 'CPDashboardAppointmentButtonViewAll'
	| 'CPDashboardAppointmentContentPreviousSection'
	| 'CPDashboardAppointmentContentNextSection'
	| 'CPDashboardAppointmentPageSectionTitle'
	| 'CPDashboardAppointmentSchedulingButton'
	| 'CPDashboardAppointmentCustomContent';

export const cpDashboardAppointmentLocs: LocDefs<CpDashboardAppointmentLoc> = {
	CPDashboardAppointmentTitleAppointments: {
		defaultValue: 'Appointments',
		description: 'Title for the appointments section',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentButtonViewAll: {
		defaultValue: 'View All',
		description: 'Button to view all appointments',
		displayPath: `${dpRoot}|View All`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentContentPreviousSection: {
		defaultValue: 'Previous Appointments Section',
		description: 'Button to view previous appointments',
		displayPath: `${dpRoot}|View Previous`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentContentNextSection: {
		defaultValue: 'Next Appointments Section',
		description: 'Button to view next appointments',
		displayPath: `${dpRoot}|View Next`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentPageSectionTitle: {
		defaultValue: 'Upcoming Appointments',
		description: 'Title for the appointments page section',
		displayPath: `${dpRoot}|Page Section|Title`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentSchedulingButton: {
		defaultValue: 'Scheduling',
		description: 'Button to view the scheduling page',
		displayPath: `${dpRoot}|Scheduling Button`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentCustomContent: {
		defaultValue: '',
		description: 'Custom content for the appointments section on the candidate dashboard.',
		displayPath: `${dpRoot}|Custom Appointment Instructions`,
		displayType: 'Content',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: true,
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CpDashboardAppointmentLoc>(cpDashboardAppointmentLocs);
export type CpDashboardAppointmentLocKeys = LocMap<CpDashboardAppointmentLoc>;
